import { type ReactNode } from "react";
import { Navigate } from "react-router";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import type { Slugs } from "src/context/ProtectedContext";
import { canAdministerSuppliers } from "../Supplier/supplierAdministration";

type SupplierAdministrationProtectionProps = {
    action: Slugs;
    children: ReactNode;
};

export const SupplierAdministrationProtection = (props: SupplierAdministrationProtectionProps) => {
    const { action, children } = props;
    const { user } = useFoodpilotContext();

    if (!canAdministerSuppliers(user.trustedUser, action)) {
        return <Navigate to="/settings" replace />;
    }

    return children;
};
